import { z } from 'zod';
import { VerificationType } from './verification-type.js';
export const totpVerificationRecordDataGuard = z.object({
    id: z.string(),
    type: z.literal(VerificationType.TOTP),
    userId: z.string(),
    secret: z.string().optional(),
    verified: z.boolean(),
});
export const sanitizedTotpVerificationRecordDataGuard = totpVerificationRecordDataGuard.omit({
    secret: true,
});
